import { useCallback, useState } from 'react';
import { type Waypoint } from 'react-waypoint';

const useSticky = () => {
  const [isSticky, setSticky] = useState(false);

  const updateStickyState = useCallback(
    ({ currentPosition, previousPosition }: Waypoint.CallbackArgs) => {
      if (currentPosition === 'inside' && previousPosition === 'above') {
        setSticky(false);
      }
      if (currentPosition === 'above' && previousPosition === 'inside') {
        setSticky(true);
      }
    },
    []
  );

  return {
    isSticky,
    updateStickyState
  };
};

export default useSticky;
